var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6514 0.666993H1.18212C0.926756 0.666498 0.692797 0.8129 0.576139 1.04605C0.457872 1.28234 0.478629 1.56689 0.629721 1.78269L5.93065 9.45126C5.93242 9.45391 5.93435 9.45639 5.93612 9.45903C6.12873 9.72606 6.23299 10.0496 6.23348 10.3819V16.634C6.23235 16.8191 6.30315 16.9971 6.43011 17.1284C6.55722 17.2596 6.73004 17.3337 6.91025 17.3337C7.00181 17.3335 7.09256 17.3148 7.1772 17.2786L10.1559 16.1124C10.4227 16.0286 10.5999 15.77 10.5999 15.4587V10.3819C10.6003 10.0496 10.7046 9.72606 10.8971 9.45903C10.8988 9.45639 10.9008 9.45391 10.9025 9.45126L16.2036 1.78252C16.3547 1.56689 16.3755 1.28251 16.2572 1.04622C16.1407 0.812899 15.9066 0.666498 15.6514 0.666993Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.11ac7d50.svg";
export { ForwardRef as ReactComponent };